import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "../card/card";
import NormalInput from "../form/HorizontalNormalInput";
import ConfirmationDlg from "../ConfirmationDlg";
import NormalSelect from "../form/HorizontalNormalSelect";
import { assetCustomField } from "../../api";

export const CustomField = ({ value, onChange }) => {
  const [fields, setFields] = useState(value);
  const [open, setOpen] = useState(false);
  const [selectedField, setSelectedField] = useState("");
  const [existingList, setExistingList] = useState([]);
  const [newField, setNewField] = useState("");

  const handleOnChange = (e) => {
    setSelectedField(e.target.value);
  };

  const getList = async () => {
    const res = await assetCustomField.list();
    if (res.ok) {
      const body = await res.json();
      if (body.data) {
        setExistingList(body.data);
      }
    }
  };

  useEffect(() => {
    setFields(value);
  }, [value]);

  useEffect(() => {
    if (open) {
      getList();
    }
  }, [open]);

  const handleAddNewField = async () => {
    if (!newField) return;
    const result = await assetCustomField.create({
      key: newField,
    });

    if (result.ok) {
      const body = await result.json();
      const data = body.data;
      setExistingList((prev) => [{ ...data }, ...prev]);
      setNewField("");
    }
  };

  const handleApplyField = () => {
    if (!selectedField) return;

    const copy = [...fields];
    copy.push({
      key: selectedField,
      value: "",
    });
    setFields(copy);
    setSelectedField("");
    onChange(copy);
    setOpen(false);
  };

  const deleteField = (i) => {
    const copy = [...fields];
    copy.splice(i, 1);
    setFields(copy);
    onChange(copy);
  };

  const handleOnChangeField = (e, i) => {
    const value = e.target.value;
    const copy = [...fields];
    copy[i].value = value;
    setFields(copy);
    onChange(copy);
  };
  return (
    <Card style={{ marginTop: "10px", marginBottom: "10px" }}>
      <CardHeader>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>Custom Fields</div>

          <div>
            <button
              onClick={() => setOpen(true)}
              className="btn btn-sm btn-outline-theme"
            >
              Add Field
            </button>
            <ConfirmationDlg
              type="submit"
              btnSubmitText={"Add"}
              onClose={() => setOpen(false)}
              title={"Select Field"}
              open={open}
              onSubmit={handleApplyField}
            >
              <NormalSelect
                value={selectedField}
                label="Field"
                onSubmit={handleAddNewField}
                onchange={handleOnChange}
                textKey={"key"}
                valueKey={"key"}
                list={existingList}
                addMoreComponent={
                  <NormalInput
                    required={true}
                    value={newField}
                    label="Key"
                    onchange={(e) => {
                      setNewField(e.target.value);
                    }}
                  />
                }
              />
            </ConfirmationDlg>
          </div>
        </div>
      </CardHeader>
      <CardBody>
        {fields.map((f, i) => (
          <div key={i} className="row">
            <div className="col-md-4">
              <NormalInput value={f.key} label="Key" />
            </div>

            <div className="col-md-7">
              <NormalInput
                value={f.value}
                onchange={(e) => handleOnChangeField(e, i)}
                label="Value"
              />
            </div>
            <div className="col-md-1" style={{ marginTop: "30px" }}>
              <button
                className="btn btn-outline-danger"
                onClick={() => deleteField(i)}
              >
                x
              </button>
            </div>
          </div>
        ))}

        {fields.length == 0 && (
          <small>Add more custom field to elaborate your asset</small>
        )}
      </CardBody>
    </Card>
  );
};
